
import React from 'react';
import { Logo } from '@/components/Logo';
import { useRSVP } from '../../context/RSVPContext';
import { navigationService } from '@/services/navigationService';

export const SuccessStep = () => {
  const {
    rsvpResponse,
    phoneNumber,
    isUpdate,
    eventId,
    selectedGuest
  } = useRSVP();

  const handleLogoClick = () => {
    if (eventId) {
      navigationService.goToEventDetails(eventId, 'rsvp');
    }
  };

  // Get the name to display - use the actual guest name from context
  const displayName = selectedGuest?.displayName || '';

  return (
    <div className="h-full flex items-start justify-center pt-[30vh]">
      <div className="text-center space-y-6 px-4">
        <div className="flex justify-center mb-8 cursor-pointer" onClick={handleLogoClick}>
          <Logo />
        </div>
        
        {isUpdate ? (
          <>
            <h2 className="text-2xl font-semibold">RSVP Updated!</h2>
            <p className="text-gray-600">Your response has been updated successfully.</p>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-semibold">Thanks for your RSVP!</h2>
            {rsvpResponse === 'yes' && phoneNumber && <p className="text-gray-600">We just messaged you.</p>}
            {rsvpResponse === 'no' && <p className="text-gray-600">We're sorry you can't make it.</p>}
          </>
        )}
      </div>
    </div>
  );
};
